import './action-modals.scss';
import GenericModal from '../../../../shared/generic-modal/generic-modal';
import { useStores } from '../../../../store';
import usePromiseFeedback from '../../../../shared/promise-feedback/usePromiseFeedback';
import { useNavigate } from 'src/utils/use-navigate';
import { EventType } from '../../../../../dtos/analytics.dto';

interface RemoveVersionModalProps {
    open: boolean;
    setOpen: (value: boolean) => void;
    versionExternalId: string;
}

export const RemoveVersionModal: React.FC<RemoveVersionModalProps> = ({open, setOpen, versionExternalId}) => {
    const {customerStore, fwVersionStore} = useStores();
    const [promiseFeedbackFactory, promiseContextHolder] = usePromiseFeedback();
    const navigate = useNavigate();

    const shouldResetPolicyMode = customerStore.isSmartPolicySecondVersionDraftReady || customerStore.isQuickStartDraftReady;

    const close = () => {
        setOpen(false);
    };

    const onVersionRemove = (versionId: string) => {

        fwVersionStore.sendGeneralEvent(EventType.LinkClicked, { button: 'delete' });
        promiseFeedbackFactory({
            promise: (async () => {
                if (shouldResetPolicyMode) {
                    return await customerStore.rollbackPolicyMode([customerStore.serviceId]);
                } else {
                    return await fwVersionStore.deleteVersion(versionId);
                }
            })(),
            successCallback: () => {
                if (!shouldResetPolicyMode) {
                    navigate(`/${customerStore.customerId}/${customerStore.serviceId}/protection/version`, { replace: true });
                }
                close();
            },
            notifObj: { show: false }
        });
    };

    const subTitle = shouldResetPolicyMode ?
        'Deleting the draft policy will redirect you to the policy selection page. Are you sure you want to delete the draft policy?' :
        'You will not be able to restore the draft once deleted.';
    const removePolicyModalBody = <div className={'remove-policy-content'}>{subTitle}</div>;

    const actionButtons = [
        {
            text: 'Cancel',
            onClick: () => close(),
            className: 'secondary-btn'
        },{
            text: 'Delete',
            onClick: () => onVersionRemove(versionExternalId),
            className: 'primary-btn'
        }];

    return open ? <>
        <GenericModal open={open}
                      body={removePolicyModalBody}
                      onCancel={close}
                      title={'Delete Draft?'}
                      actionButtons={actionButtons}
                      wrapClassName={'remove-policy-modal'}
        />
        {promiseContextHolder}
    </>: null;
};
